import { Component } from '@angular/core';
import { Platform, NavParams, ViewController, AlertController } from 'ionic-angular';

@Component({selector: 'page-findrecipe', templateUrl: 'findrecipe.html'})
export class FindRecipePage {
  items;
  add : boolean = false;
  conector;
  constructor(
    public platform: Platform,
    public params: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl : AlertController
  ) {
    this.initializeItems();
    this.add = this.params.get('add');
    this.conector = "";
  }

  initializeItems() {
    this.items = this.params.get('recipes');
  }


  selected(item){
    if(this.add && this.conector==""){
      let alert = this.alertCtrl.create({
        title: 'No elegiste conector',
        subTitle: 'Debes elegir un conector',
        buttons: ['Aceptar']
      });
      alert.present();
      return false;
    }
    this.viewCtrl.dismiss({
      "id":item.key,
      "name": item.name,
      "duration" : Number(item.duration),
      "conector" : this.conector,
      "first" : !this.add
    })
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((item.name.toLowerCase().indexOf(val.toLowerCase()) > -1)||(item.key.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/menus/findrecipe.ts